import { uiText, useUiLanguage } from '../../../../../utils/uiTranslation';
import React from 'react';

const TOTAL_SEGMENTS = 18;

const HireOutcomes = ({ title, subtitle, metrics, isRTL = false }) => { useUiLanguage(); return (<article className="executive-overview-panel executive-overview-outcomes">
    <div className="executive-overview-card-title">{title}</div>
    {subtitle ? <p className={`executive-overview-outcomes-copy${isRTL ? ' rtl' : ''}`}>{subtitle}</p> : null}

    <div className="executive-overview-outcomes-list">
      {metrics.length ? metrics.map((metric) => {
        const filledSegments = Math.max(
          0,
          Math.min(TOTAL_SEGMENTS, Math.round(((metric.progress || 0) / 100) * TOTAL_SEGMENTS))
        );

        return (
          <div key={metric.label} className="executive-overview-outcome-item">
            <div className="executive-overview-outcome-head">
              <div className="executive-overview-outcome-meta">
                <span className="executive-overview-outcome-label">{uiText(metric.label)}</span>
                <span className={`executive-overview-outcome-trend ${metric.tone || 'neutral'}`}>
                  {metric.trend}
                </span>
              </div>

              <strong className="executive-overview-outcome-value">{metric.value}</strong>
            </div>

            <div className="executive-overview-outcome-track" aria-hidden="true">
              {Array.from({ length: TOTAL_SEGMENTS }).map((_, index) => (
                <span
                  key={`${metric.label}-${index}`}
                  className={`executive-overview-outcome-segment ${metric.tone || 'neutral'} ${
                    index < filledSegments ? 'filled' : ''
                  }`}
                />
              ))}
            </div>
          </div>
        );
      }) : (
        <div className="executive-overview-empty-state">
          {isRTL ? 'لا توجد بيانات نتائج مباشرة متاحة بعد.' : 'No live outcome data is available yet.'}
        </div>
      )}
    </div>
  </article>); };

export default HireOutcomes;
